import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { isEqual } from 'lodash';
import GoogleMap from 'google-map-react';
import { Image, MapMarker } from '@components/common';
import classNames from 'classnames';
import utils, { constants } from '@utils';

import { getCityStateZipString } from '@config/utils';

class MapPanel extends Component {
	shouldComponentUpdate = ({ location }) => {
		const { location : lastLocation } = this.props;
		return (
			!isEqual(location, lastLocation)
		);
	}

	getButton = (parameters) => {
		const button = (
			<a
				className={parameters.className}
				href={parameters.href}
				onClick={parameters.onClick}
				target={parameters.target}
			>
				<i className={classNames('margin-right-5', parameters.iconClass)} />
				{ parameters.text }
			</a>
		);

		return button;
	}

	getLocationData = (title, value = 0) => (
		<div className="flex-1 text-center">
			<small className="color-gray-silver">{title}</small>
			<h5 className="margin-top-5 margin-bottom-0 color-dark">{value}</h5>
		</div>
	);

	getIcon = (iconClass) => (
		<i className={`${iconClass} color-gray-silver margin-right-10`} />
	);

	render() {
		const { location } = this.props;

		const center = {
			lat : parseFloat(location.Latitude),
			lng : parseFloat(location.Longitude),
		};

		let address = `${location.Latitude.toFixed(6)},${location.Longitude.toFixed(6)}`;

		if (location.StreetAddress1) {
			address = `${location.StreetAddress1}, ${location.StreetAddress2
				? `${location.StreetAddress2},`
				: ''} ${getCityStateZipString(location.City, location.State, location.Zipcode)}`;
		}

		return (
			<Col
				md={4}
				className="map-panel-container"
			>
				<div className="height-150">
					{
						/**
						 * If we ever need to change the zoom using a variable,
						 * then we need to use the property zoom, instead of defaultZoom.
						 *
						 * Because defaultZoom must never change.
						 */
					}
					<GoogleMap
						defaultZoom={15}
						center={center}
						bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
						options={constants.GOOGLE_MAP_OPTIONS}
					>
						<MapMarker
							lat={center.lat}
							lng={center.lng}
						/>
					</GoogleMap>
				</div>
				<Col sm={12}>
					<div className="text-center margin-top-20 padding-left-30 padding-right-30">
						<h4 className="color-dark margin-bottom-5">{ location.Name }</h4>
						<p>{ address }</p>
					</div>
					<div className="separator" />
					<div className="padding-left-10 padding-right-10">
						{ this.getIcon('rkf rkf-dollar-circle') }
						<small>Avg. Officer Rate</small>
						<h5 className="color-dark font-bold margin-left-24 margin-top-5">
							$
							{ parseFloat(location.AverageOfficerRate || 0).toFixed(2) }
							/hr
						</h5>
					</div>
					<div className="separator" />
					<div className="padding-left-10 padding-right-10">
						{ this.getIcon('rkf rkf-profile') }
						<small>Contact</small>
						<h5 className="color-dark font-bold margin-left-24 margin-top-0">{location.OrganizationContactName}</h5>
						<div className="margin-left-24">
							{
								this.getButton({
									className : classNames(
										'btn btn-link btn-small padding-left-0 margin-right-20',
										{ hidden : !location.OrganizationContactEmail },
									),
									href      : `mailto:${location.OrganizationContactEmail}`,
									target    : '_blank',
									iconClass : 'rkf rkf-email',
									text      : 'Email',
								})
							}
							{
								this.getButton({
									className : classNames(
										'btn btn-link btn-small padding-left-0 color-gray-dove',
										{ hidden : !location.OrganizationContactPhone },
									),
									href      : `tel:${location.OrganizationContactPhone}`,
									target    : '_blank',
									iconClass : 'rkf rkf-phone',
									text      : utils.formatPhoneNumber(location.OrganizationContactPhone),
								})
							}
						</div>
					</div>
					<div className="separator" />
					<div className="padding-left-10 padding-right-10">
						<span className="display-block">
							{ this.getIcon('rkf rkf-analytics') }
							<strong className="color-dark font-bold">Key Stats</strong>
						</span>
						<div className="flex margin-top-5">
							{ this.getLocationData('Total Jobs', location.TotalJobCount) }
							{ this.getLocationData('Total Hours', parseFloat(location.TotalJobHours || 0).toFixed(2)) }
							{ this.getLocationData('Unique Officers', location.UniqueOfficersCount) }
						</div>
					</div>
					<div className="separator" />
					<div className="display-block padding-bottom-30">
						<div className="flex">
							<Image
								src={location.OrganizationPhotoUrl}
								className="img-circle height-20 width-20 margin-right-10 img-cover"
							/>
							<div className="flex-1">
								<small>Agency/Coordinator</small>
								<h5 className="color-dark font-bold margin-top-0">{location.OrganizationName}</h5>
							</div>
						</div>
						<div className="margin-left-30 margin-top-5">
							{
								this.getButton({
									className : classNames('btn btn-link btn-small padding-left-0 margin-right-20', { hidden : !location.OrganizationEmail }),
									href      : `mailto:${location.OrganizationEmail}`,
									target    : '_blank',
									iconClass : 'rkf rkf-email',
									text      : 'Email',
								})
							}
							{
								this.getButton({
									className : classNames('btn btn-link btn-small padding-left-0 color-gray-dove', { hidden : !location.OrganizationPhone }),
									href      : `tel:${location.OrganizationPhone || 0}`,
									target    : '_blank',
									iconClass : 'rkf rkf-phone',
									text      : utils.formatPhoneNumber(location.OrganizationPhone || 0),
								})
							}
						</div>
					</div>
				</Col>
			</Col>
		);
	}
}

MapPanel.propTypes = {
	location : PropTypes.object.isRequired,
};

export default MapPanel;
